import { getValue } from "@utils/lodash";
import React from "react";

function CustomFileUpload(props) {
	const {
		handleDrop,
		uploadLoading,
		handleDragOver,
		disableUpload,
		handleUploadDocuments,
		isDisabled
	} = props;
	return (
		<div
			onDrop={handleDrop}
			onDragOver={
				!uploadLoading
					? getValue(props, `permissions`, []).includes("update")
						? handleDragOver
						: disableUpload
					: disableUpload
			}
			className="mt-3 mb-3"
		>
			<p className="mb-2">Files Upload{" 	"}</p>
			<label className="custom-file-upload-popup">
				{/* <p>{uploadLoading ? "Please wait..." : "Upload Files"} </p> */}
				{uploadLoading ? (
					<p>Please wait...</p>
				) : (
					<>
						<p className="custom-inputfile__attach">Drag & Drop Files here</p>
						<p className="custom-inputfile__attach">OR</p>
						<a>
							<p className="custom-inputfile__attach">Browse Files</p>
						</a>
					</>
				)}
				<input
					type="file"
					onChange={
						!uploadLoading
							? getValue(props, `permissions`, []).includes("update")
								? handleUploadDocuments
								: disableUpload
							: disableUpload
					}
					multiple
					className="d-none"
					disabled={isDisabled}
				/>
			</label>
		</div>
	);
}

export default CustomFileUpload;
